import { render } from "./InputGroup.vue?vue&type=template&id=75450586"
import script from "./InputGroup.vue?vue&type=script&lang=js"
export * from "./InputGroup.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__